// extracted by mini-css-extract-plugin
module.exports = {"GroupButton":"GroupButton_GroupButton__1U2k1","LabelButton":"GroupButton_LabelButton__jCoux"};